import axios from "axios";
import TokenService from "./tokenManager";
import { commonHeaders } from "./commonHeader";
import { API_BASE_URL } from "config";

const HttpClient = axios.create({
  // baseURL: "https://digitallending.accessbankplc.com:9092",
  baseURL:API_BASE_URL,
  headers: commonHeaders,
});

export function refreshSessionOrLogout() {
  return async (err: any) => {
    const { config } = err;
    // Access Token was expired, refresh session or bailout
    // A 401 from a login call means bad credentials, a rejected 2FA code or an
    // expired login request token, so it must stay on the sign in page, not
    // trigger a refresh
    if (
      err.response?.status === 401 &&
      !config?.url?.includes("/api/Account/login") &&
      !config?.url?.includes("/api/Account/complete-login") &&
      !config?.url?.includes("/api/Account/mfa-activation-code") &&
      !config?.url?.includes("/api/Account/resend-mfa-code")
    ) {
      try {
        const response = await HttpClient.post("/api/Account/refresh-token", {
          AccessToken: TokenService.getLocalAccessToken(),
          RefreshToken: TokenService.getLocalRefreshToken(),
          ExpiresIn: TokenService.getExpiresIn(),
        });

        if (response.status === 200) {
          TokenService.updateLocalAccessToken(response.data.Data.AccessToken);
          TokenService.updateLocalRefreshToken(response.data.Data.RefreshToken);
          window.location.reload();
        }

        return axios(config);
      } catch (error) {
        TokenService.removeUser();
        window.location.href = "/";
      }
    }

    return Promise.reject(err);
  };
}
